<template>
    <div class="bg-gray-100">
        <TopLocationHero title-key="millennium.title" static-image-key="millennium___hero" />

        <div class="relative mt-4 sm:mt-12 z-1">
            <a id="main-content" class="fixed top-0" tabindex="-1"></a>

            <div class="container hidden sm:block">
                <Breadcrumb :items="breadcrumbItems" />
            </div>

            <TopLocationBackgroundShape1 />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- GENERIC INFO -->
        <!-- * -->
        <div class="relative mt-10 z-2">
            <div class="container">
                <Type1Block
                    title-key="millennium.intro.title"
                    description-key="millennium.intro.description"
                    :img="require('assets/images/illustrations/buildings/millennium.svg')"
                    building-name-key="millennium.intro.building_name"
                    building-area-key="millennium.intro.building_area"
                    building-architect-key="millennium.intro.building_architect"
                    building-contractor-key="millennium.intro.building_contractor"
                />
            </div>
        </div>

        <div class="container relative z-2 mt-16 sm:mt-20">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- THE SUCCESS OF ZSOLNAY -->
            <!-- * -->
            <Type8Block
                title-key="millennium.zsolnay_success.title"
                description-key="millennium.zsolnay_success.description"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- MOSAIQUE GALLERY -->
        <!-- * -->
        <div v-if="galleryImages1" class="relative z-1 mt-16 sm:mt-20">
            <div class="container relative z-1">
                <MosaiqueGalleryBlock :items="galleryImages1" />
            </div>
            <TopLocationBackgroundShape4 flip-y flip-x class="-bottom-16 md:-bottom-28 lg:-bottom-32" />
        </div>

        <div class="container relative z-2 mt-16 sm:mt-20">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- THE SUCCESS OF ZSOLNAY -->
            <!-- * -->
            <Type5Block v-if="galleryImages2" :items="galleryImages2" />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- NEO -->
            <!-- * -->
            <Type9Block
                title-key="millennium.neo.title"
                description-key="millennium.neo.description"
                static-image-key="millennium___neo"
                class="mt-16 sm:mt-20"
            />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- ZSOLNAY RESTAURANT & CAFE -->
            <!-- * -->
            <Type8Block
                title-key="millennium.zsolnay_cafe.title"
                description-key="millennium.zsolnay_cafe.description"
                class="mt-16 sm:mt-20"
            />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- ZSOLNAY FOUNTAIN -->
            <!-- * -->
            <Type8Block
                title-key="millennium.zsolnay_fountain.title"
                description-key="millennium.zsolnay_fountain.description"
                class="mt-16 sm:mt-20"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- GALLERY -->
        <!-- * -->
        <XXLGalleryCarousel v-if="galleryImages3" :images="galleryImages3" class="mt-16 sm:mt-20" />

        <div class="container mt-16 sm:mt-20">
            <TopLocationProjectPageBanner
                v-if="$t('millennium.event_recommendation_button_url').length"
                :button-text="$t('millennium.event_recommendation_button_label')"
                :button-url="$t('millennium.event_recommendation_button_url')"
                label-text-key="millennium.event_recommendation_text"
                type="event"
            />

            <TopLocationProjectPageBanner
                :button-text="$t('millennium.visit_project_button_label')"
                :button-url="$t('millennium.visit_project_button_url')"
                label-text-key="millennium.visit_project_text"
                class="mt-4 sm:mt-8"
            />

            <AwardsBlock
                v-if="awards"
                :title="awards.title"
                :description="awards.description"
                :media="awards.media"
                class="mt-16 sm:mt-20"
            />
        </div>
    </div>
</template>

<script>
import TopLocationProjectPageBanner from '@/components/Pages/TopLocation/TopLocationProjectPageBanner.vue';
import AwardsBlock from '@/components/Blocks/AwardsBlock/AwardsBlock.vue';
import Type1Block from '@/components/Blocks/Type1Block/Type1Block.vue';
import TopLocationHero from '@/components/Pages/TopLocation/Hero/Hero.vue';
import TopLocationBackgroundShape1 from '@/components/Pages/TopLocation/TopLocationBackgroundShape1.vue';
import Type5Block from '@/components/Blocks/Type5Block/Type5Block.vue';
import Type9Block from '@/components/Blocks/Type9Block/Type9Block.vue';
import XXLGalleryCarousel from '@/components/Carousels/XXLGalleryCarousel/XXLGalleryCarousel.vue';
import Type8Block from '@/components/Blocks/Type8Block/Type8Block.vue';
import MosaiqueGalleryBlock from '@/components/Blocks/MosaiqueGalleryBlock/MosaiqueGalleryBlock.vue';
import TopLocationBackgroundShape4 from '@/components/Pages/TopLocation/TopLocationBackgroundShape4.vue';

export default {
    name: 'HouseOfTheHungarianMillennium',
    components: {
        AwardsBlock,
        TopLocationProjectPageBanner,
        TopLocationBackgroundShape4,
        MosaiqueGalleryBlock,
        Type8Block,
        Type1Block,
        TopLocationHero,
        TopLocationBackgroundShape1,
        Type5Block,
        Type9Block,
        XXLGalleryCarousel,
    },
    async asyncData({ $axios, i18n }) {
        let galleryImages1 = null;
        let galleryImages2 = null;
        let galleryImages3 = null;
        let awards = null;

        await Promise.allSettled([
            $axios.$get('/galleries/reference/top-location___millennium-1'),
            $axios.$get('/galleries/reference/top-location___millennium-2'),
            $axios.$get('/galleries/reference/top-location___millennium-3'),
            $axios.$get('/awards/reference/millennium'),
        ])
            .then(([galleryImages1Res, galleryImages2Res, galleryImages3Res, awardsRes]) => {
                if (galleryImages1Res.status === 'fulfilled') {
                    galleryImages1 = galleryImages1Res.value.slides;
                }

                if (galleryImages2Res.status === 'fulfilled') {
                    galleryImages2 = galleryImages2Res.value.slides;
                }

                if (galleryImages3Res.status === 'fulfilled') {
                    galleryImages3 = galleryImages3Res.value.slides;
                }

                if (awardsRes.status === 'fulfilled' && awardsRes.value.is_on_top_locations) {
                    awards = awardsRes.value;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('navigation.top_locations'), 'top-locations', true]);
        breadcrumbItems.push([i18n.t('millennium.title'), 'house-of-the-hungarian-millennium']);

        return {
            galleryImages1,
            galleryImages2,
            galleryImages3,
            awards,
            breadcrumbItems,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('top-locations.house-of-the-hungarian-millennium'),
            meta: this.$getPageMetaData('top-locations.house-of-the-hungarian-millennium'),
        };
    },
};
</script>

<style scoped></style>
